module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_10_C_1.cafa2a10.mp3";